var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';

import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';

import ReactQuill, { Quill } from 'react-quill';

import { compareStrings } from '../utils/stringUtilts';
import { sortArray } from '../utils/arrayUtils';

import 'react-quill/dist/quill.snow.css';

/*
* Importar fontes customizadas para o componentes
*
* Não funciona se colocar dentro de uma função
* */
var Font = Quill.import('formats/font');
Font.whitelist = sortArray([].concat(Font.whitelist, ['Arial', 'Arial-Black']), compareStrings);
Quill.register(Font, true);

function RichTextField(props) {
    var label = props.label,
        options = props.options,
        value = props.value,
        disabled = props.disabled,
        readonly = props.readonly,
        autofocus = props.autofocus,
        onBlur = props.onBlur,
        onFocus = props.onFocus,
        schema = props.schema,
        formContext = props.formContext,
        registry = props.registry,
        inputProps = _objectWithoutProperties(props, ['label', 'options', 'value', 'disabled', 'readonly', 'autofocus', 'onBlur', 'onFocus', 'schema', 'formContext', 'registry']);

    var onChange = function onChange(content, delta, source, editor) {
        return props.onChange(content ? content : options.emptyValue);
    };

    var modules = {
        toolbar: [['bold', 'italic', 'underline', 'strike'], // toggled buttons
        ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], // custom button values
        [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], // superscript/subscript
        [{ 'indent': '-1' }, { 'indent': '+1' }], // outdent/indent
        [{ 'direction': 'rtl' }], // text direction

        [{ 'size': ['small', false, 'large', 'huge'] }], // custom dropdown
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], // dropdown with defaults from theme
        [{ 'font': Font.whitelist }], [{ 'align': [] }], ['clean']]
    };

    return React.createElement(
        'section',
        null,
        React.createElement(
            FormControl,
            { component: 'fieldset' },
            React.createElement(
                FormLabel,
                {
                    component: 'legend',
                    style: { padding: '6px 0 7px' }
                },
                label
            )
        ),
        React.createElement(
            FormGroup,
            { style: { flexWrap: 'nowrap' } },
            React.createElement(ReactQuill, _extends({
                modules: modules,
                readOnly: readonly,
                disabled: schema.disabled,
                autoFocus: autofocus,
                value: value || ''

            }, inputProps, {
                onChange: onChange,
                onBlur: onBlur && function (range) {
                    return onBlur(inputProps.id, range);
                },
                onFocus: onFocus && function (range) {
                    return onFocus(inputProps.id, range);
                }
            }))
        )
    );
}

export default RichTextField;